import React, {PureComponent} from 'react'
import styled from 'styled-components'
import {Link, withRouter} from 'react-router-dom'
// import * as Cookies from 'js-cookie'
import get from 'lodash/get'
import {Icon} from './Icon'


const Container = styled.div`
  width: 100%;
  background: #fd7e15;
  display: flex;
  padding: 10px 16px; 
  align-items: center;
  box-shadow: -3px -4px 11px 0px #000;
  position: fixed;
  z-index: 9999;
`
const Title = styled.h2`
  color: #020266;
  margin: 0;
  padding-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & a{
    color: #fff;
    font-size:14px;
    display: block;
    font-weight: 500;
  }
`
const MenuIcon = styled.div`
  position: relative;
  width: 35px;
  height: 30px;
`
const AnimatedIcon = styled.div`
    top: 13px;
    position: absolute;
    width: 35px;
    height: 4px;
    transition-timing-function: ease;
    transition-duration: .15s;
    transition-property: transform;
    border-radius: 4px;
    background-color: #fff;
    &::after, ::before{
      content: "";
      display: block;
      position: absolute;
      width: 35px;
      height: 4px;
      transition-timing-function: ease;
      transition-duration: .15s;
      transition-property: transform;
      border-radius: 4px;
      background-color: #fff;

    }
    &:after{
      bottom: -10px;
    }
    &:before{
      top: -10px;
    }
${props=> props.active && `
top: 5px;
    transform: translate3d(0,10px,0) rotate(45deg);
    &:before{
      transform: rotate(-45deg) translate3d(-5.71429px,-6px,0);
    opacity: 0; 
    top: 10px;
    transition-timing-function: ease;
    transition-duration: .15s;
    transition-property: transform,opacity;
    }
    &:after{
      TOP: 20px;
      transform: translate3d(0,-20px,0) rotate(-90deg);
    }
`}
`
 const BackIcon = styled.div`
   width: 26px;
    height: 4px;
    top:12px;
    position: relative;
    background: #fff;
    &::after, ::before{
      content: "";
      display: block;
      position: absolute;
      width: 15px;
      height: 4px;
      transition-timing-function: ease;
      transition-duration: .15s;
      transition-property: transform;
      border-radius: 4px;
      background-color: #fff;
    }
    &:after{
    transform: translate3d(0,10px,0) rotate(-45deg);
    left: -3px;
    top: -14px;
    }
    &:before{
    transform: translate3d(0,10px,0) rotate(45deg);
    left: -3px;
    top: -5px;
    }

 `
const SideMenu = styled.div`
  background: #020266;
  top:0px;
  padding-top: 60px
  position: fixed;
  height: 100%;
  width: 200px;
  z-index: 999;
  left: ${props=> props.open ? '0px' : '-210px'};
  transition-timing-function: ease;
    transition-duration: .15s;
    transition-property: transform,left;
  & * {
    color: #fff;
  }
`

const Anchor = styled(Link)`
    display: flex;
    align-items: center;
    background: ${(props)=> props.selected ? "#fd7e15" : 'transparent' };
    padding: 10px 12px;
    text-decoration: none;
    color: #fff;
    & > svg{
      margin-right: 10px;
    }
`

class Header extends PureComponent{
  state={
    open: false
  }

  handleLogout=()=>{
    localStorage.removeItem('userId')
    localStorage.removeItem('userData')
    this.props.history.push("/login");
  }
  render(){
    const {backIcon, style, clickOnBackIcon}=this.props

    return(
      <React.Fragment>
      <Container style={{...style}}>
        {backIcon ?
        <MenuIcon onClick={()=> clickOnBackIcon ? clickOnBackIcon() : this.props.history.goBack()}>
         <BackIcon/>  
         </MenuIcon>
        :<MenuIcon onClick={()=> this.setState({open: !this.state.open})}>
          <AnimatedIcon active={this.state.open}/>
        </MenuIcon>}
        <Title> PMAY(U)</Title>  
      </Container>
      <SideMenu open={this.state.open}>
        <Anchor to='/' selected={get(this.props,'location.pathname')==='/'}> <Icon icon='home' color='#fff'/> Home </Anchor>
        <Anchor to='/nearest-beneficiaries' selected={get(this.props,'location.pathname')==='/nearest-beneficiaries'}> <Icon icon='users' color='#fff'/> Projects & beneficiaries </Anchor>
        <Anchor to='/form' selected={get(this.props,'location.pathname')==='/form'}> <Icon icon='transactions' color='#fff'/> Inspection Form </Anchor>
        <Anchor to='/history' selected={get(this.props,'location.pathname')==='/history'}><Icon icon='reports' color='#fff'/> History </Anchor>
        <Anchor to='/login' onClick={()=> this.handleLogout()}><Icon icon='logout' color='#fff'/> Logout </Anchor>
      </SideMenu>
      </React.Fragment>
    )
  }
}

export default withRouter(Header)